// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AvatarPreviewController from "./avatar_preview_controller"
application.register("avatar-preview", AvatarPreviewController)

import BookSearchController from "./book_search_controller"
application.register("book-search", BookSearchController)

import ChartController from "./chart_controller"
application.register("chart", ChartController)

import ColorTagController from "./color_tag_controller"
application.register("color-tag", ColorTagController)

import CoverPreviewController from "./cover_preview_controller"
application.register("cover-preview", CoverPreviewController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import MobileSearchController from "./mobile_search_controller"
application.register("mobile-search", MobileSearchController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import PostBannerController from "./post_banner_controller"
application.register("post-banner", PostBannerController)

import ProfileTabsController from "./profile_tabs_controller"
application.register("profile-tabs", ProfileTabsController)

import SpoilerController from "./spoiler_controller"
application.register("spoiler", SpoilerController)

import SubmitController from "./submit_controller"
application.register("submit", SubmitController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)
